import { createServiceFactory } from '@/services/factory'
import { createMockSessionService } from './sessions.mock'
import { createHttpSessionService } from './sessions.http'

export type { SessionService, SessionStats } from './sessions.service'

export const getSessionService = createServiceFactory(
  'sessions',
  createMockSessionService,
  createHttpSessionService
)
